export const DCPStatuses = {
  dispatched: 'dispatched',
  executing: 'executing',
  queued: 'queued',
  failed: 'failed',
  error: 'error',
  succeeded: 'succeeded',
  cancelled: 'cancelled',
  scheduled: 'scheduled',
  downloading: 'downloading',
  downloaded: 'downloaded',
  expired: 'expired',
  pending: 'pending',
  delivered: 'delivered',
  pending_cancellation: 'pending_cancellation'
}

export const ShipmentStatuses = {
  Pending: 'Pending',
  InfoReceived: 'InfoReceived',
  InTransit: 'InTransit',
  OutForDelivery: 'OutForDelivery',
  AttemptFail: 'AttemptFail',
  Delivered: 'Delivered',
  Exception: 'Exception',
  Expired: 'Expired'
}

export const DCPDeliveryType = {
  THEATRE_APPLIANCE: 'THEATRE_APPLIANCE',
  PARTNERS: 'partners'
}

export const KDMStatuses = {
  success: 'success',
  emailed: 'emailed',
  inprogress: 'inprogress',
  failed: 'failed',
  generated: 'generated'
}

export const CPLAttributes = {
  type: 1,
  resolution: 2,
  stereoType: 3,
  aspectRatio: 4,
  audioFormats: 5,
  language: 6,
  subtitleLanguage: 7,
  closedCaptions: 8,
  ratings: 9
}


// WEBPACK FOOTER //
// ./src/app/common/enums.js